import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=c72bae0e&scoped=true&"
import script from "./hospital.vue?vue&type=script&lang=js&"
export * from "./hospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72bae0e",
  null
  
)

export default component.exports